export default __webpack_public_path__ + "static/media/right.bd27ae48.svg";